export const APPLICATION_ITEMS = [{ id: 'XSS', name: 'XSS' }];
